module.exports = __webpack_public_path__ + "static/media/image1.49b5fba2.jpg";